import {
  type FieldErrors,
  type FieldPath,
  type FieldValues,
  type UseFormRegisterReturn,
} from 'react-hook-form';

type MyInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  name: TName;
  label: string;
  className?: string;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
  register: UseFormRegisterReturn<string>;
  errors: FieldErrors<TFieldValues>;
  rows?: number;
};

export const RHFTextArea = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  label,
  className = '',
  readOnly = false,
  disabled = false,
  placeholder,
  register,
  errors,
  rows,
}: MyInputProps<TFieldValues, TName>) => {
  const errorMessage =
    typeof errors[name]?.message === 'string' ? errors[name].message : '';
  return (
    <div className='mb-2 py-2'>
      <label
        htmlFor={name}
        className='flex justify-between text-xs font-bold uppercase'
      >
        {label}
      </label>

      <textarea
        id={name}
        readOnly={readOnly}
        disabled={disabled}
        placeholder={placeholder ?? label}
        rows={rows}
        {...register}
        className={`${className} g-gray-50 mt-1 block w-full  rounded-lg border border-gray-500 p-2.5
                  text-gray-900 focus:border-blue-500 focus:ring-blue-500
                   dark:border-0 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-gray-400
                     ${errorMessage ? 'border-rose-600 dark:border-rose-400' : ''}`}
      />

      {errorMessage && (
        <span className='text-xs text-rose-600 dark:text-rose-400'>
          {errorMessage}
        </span>
      )}
    </div>
  );
};
